import Cookies from 'js-cookie';

import { useApplication } from '@bonusly/application';

import { CSRF_COOKIE_ID } from '../config/csrf';
import { useIdentityStore } from '../lib/store';
import { isExpired } from '../utils/token';
import { joinPath } from '../utils/url';

export const getToken = async () => {
	const token = useIdentityStore.getState().token;

	// If there is no token or an old token without an expiration date, return it. The server will
	// return a 401 if the token is invalid/absent and the user will be redirected to the login page.
	if (!token || !isExpired(token)) {
		return Promise.resolve(token);
	}

	const refreshed = await refreshToken();

	return refreshed;
};

export const fetchToken = async (): Promise<string | undefined> => {
	const application = useApplication.getState().application;
	const csrfToken = Cookies.get(CSRF_COOKIE_ID);
	const url = joinPath(application.recognizeOrigin, 'api/v2/jwt');
	const res = await fetch(url, {
		credentials: 'include',
		headers: {
			'X-BONUSLY-SOURCE': 'internal',
			...(csrfToken && {
				[CSRF_COOKIE_ID]: csrfToken,
			}),
		},
	});

	const json = await res.json();

	return json.jwt;
};

export const refreshToken = async (): Promise<string | undefined> => {
	const jwt = await fetchToken();

	useIdentityStore.setState({ token: jwt });

	return jwt;
};
